module.exports = __webpack_public_path__ + "img/agv.0449bbde.png";